import i18next from "i18next";

export const getImageNameFromURL = (url) => {
  const splitUrl = url.split("/");
  const imageName = splitUrl[splitUrl.length - 1];
  return imageName;
};

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const sessionKey = Object.freeze({
  TOKEN: "token",
  USER_ID: "userId",
});

export const getToken = () => {
  const token = sessionStorage.getItem(sessionKey.TOKEN);
  return token;
};
export const setToken = (token) => {
  sessionStorage.setItem(sessionKey.TOKEN, token);
};
export const setUserIdStorage = (id) => {
  sessionStorage.setItem(sessionKey.USER_ID, JSON.stringify(id));
};
export const getUserIdStorage = () => {
  const userId = JSON.parse(sessionStorage.getItem(sessionKey.USER_ID));
  return userId;
};

export const statusOptions = [
  { value: -2, label: "Không đạt yêu cầu", color: "#800000" },
  { value: -1, label: "Không duyệt", color: "#800000" },
  { value: 0, label: "Đang chờ duyệt", color: "#800080" },
  { value: 1, label: "Đang phỏng vấn", color: "#003df5" },
  { value: 2, label: "Đạt yêu cầu", color: "#25d366" },
  { value: 3, label: "Đã nhận việc", color: "#ffaa0e" },
];

export const actionGroup = [
  { value: "dashboard", label: "Tổng quan" },
  { value: "company", label: "Công ty" },
  { value: "department", label: "Bộ phận" },
  { value: "group", label: "Tổ (nhóm)" },
  { value: "user", label: "Người dùng" },
  { value: "shift", label: "Ca làm việc" },
  { value: "attendance", label: "Chấm công" },
  { value: "action", label: "Hành động" },
  { value: "role", label: "Vai trò" },
  { value: "application", label: "Ứng tuyển" },
  { value: "history", label: "Lịch sử" },
  { value: "actionHistory", label: "Lịch sử hành động" },
  { value: "message", label: "Tin nhắn" },
  { value: "groupAndBot", label: "Quản lý bot và group" },
];

export const listRouter = [
  { key: "dashboard-employee", value: false, url: "dashboard-employee" },
  { key: "dashboard-application", value: false, url: "dashboard-application" },
  { key: "dashboard-history", value: false, url: "dashboard-history" },
  { key: "department", value: false, url: "company-management" },
  { key: "department", value: false, url: "department-management" },
  { key: "department", value: false, url: "group-management" },
  { key: "user", value: false, url: "employee-manager" },
  { key: "application", value: false, url: "application-management" },
  { key: "shift", value: false, url: "shift" },
  { key: "action", value: false, url: "action" },
  { key: "role", value: false, url: "role" },
  { key: "history", value: false, url: "history" },
  { key: "history", value: false, url: "duplicate-ip" },
  { key: "history", value: false, url: "duplicate-fp" },
  { key: "history", value: false, url: "duplicate-ip-fp" },
  { key: "history", value: false, url: "duplicate-ip-old" },
  { key: "history", value: false, url: "duplicate-fp-old" },
  { key: "actionHistory", value: false, url: "action-history" },
  { key: "bot-chat", value: false, url: "bot" },
  { key: "bot-chat", value: false, url: "message" },
];

export const listMonth = (date, month) => {
  let listMonth = [];
  let yearCurrent = date.getFullYear();
  let monthCurrent = date.getMonth() + 1;
  let year = 2023;
  let label;
  let value;

  while (year <= yearCurrent) {
    if (month > 12) {
      year += 1;
      month = 1;
      if (year <= yearCurrent) {
        label = `${i18next.t("month")} ${month}/${year}`;
        value = [month, year].toString();
        listMonth.push({ value, label });
        month += 1;
      }
    } else {
      if (year <= yearCurrent && month <= monthCurrent) {
        label = `${i18next.t("month")} ${month}/${year}`;
        value = [month, year].toString();
        listMonth.push({ value, label });
        month += 1;
      } else {
        month += 1;
      }
    }
  }
  return listMonth;
};

export const listYear = (date) => {
  let yearCurrent = date.getFullYear();
  let data = [];
  let year = 2023;
  let value;
  let label;
  while (year <= yearCurrent) {
    label = `${i18next.t("year")} ${year}`;
    value = year++;
    data.push({ value, label });
  }

  return data;
};
